import script from "./tag-label.vue?vue&type=script&setup=true&lang=ts"
export * from "./tag-label.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__